module.exports = __webpack_public_path__ + "static/p04_burroPataBott-1387a33a4ad071be9fa9952279ccebf0.png";